import { render, staticRenderFns } from "./Industria.vue?vue&type=template&id=18da751c&"
import script from "./Industria.vue?vue&type=script&lang=js&"
export * from "./Industria.vue?vue&type=script&lang=js&"
import style0 from "./Industria.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports